"use strict";

var Referral = {
  $timerID: undefined,
  $phone: undefined,
  $status: undefined,
  onload: document.addEventListener('DOMContentLoaded', function () {
    Referral.init();
  }),
  init: function init() {
    this.bind();
  },
  bind: function bind() {
    $(document).on('click', 'button.copy-invite-data', function (e) {
      e.preventDefault();
      var notify = $(this).attr('data-notify');
      var data = $(this).closest('div').find('.send-invite__text--copy').html().trim();
      var input = $("<input>");
      $("body").append(input);
      input.val(data).select();
      document.execCommand("copy");
      input.remove();
      Notify.successfulNotification(notify);
    }).on('click', 'button.copy-profile-link', function (e) {
      e.preventDefault();
      var notify = $(this).attr('data-notify');
      var data = $('.profile-link-for-copy').val();
      var input = $("<input>");
      $("body").append(input);
      input.val(data).select();
      document.execCommand("copy");
      input.remove();
      Notify.successfulNotification(notify);
    }).on('click', 'button.send-email-invite', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Referral.ajax.sendReferralInviteEmail($(this), $('input.send-email-invite'));
    }).on('input', 'input.send-email-invite', function () {
      $(this).closest('form').find('.error').hide();
    }).on('click', '.search-invites', function () {
      Referral.ajax.searchInvites($(this).attr('data-value'));
    }).on('click', '#request-withdraw-bonus', function () {
      Referral.ajax.requestWithdrawBonus($('#withdraw-bonus-sum').val());
    }).on('click', '#close-withdrawal-popup', function () {
      window.location.reload();
    });
    var $page = $('html, body');
    $('a[href*="#"]').click(function () {
      $page.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
      }, 400);
      return false;
    });
  },
  ajax: {
    url: AJAX_URL,
    obj: {},
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
        VerifyPhone.ajax.obj = {};
      }, 'JSON');
    },
    sendReferralInviteEmail: function sendReferralInviteEmail(btn, input) {
      this.obj.method = 'sendReferralInviteEmail';
      this.obj.email = input.val().length > 0 ? input.val() : ' ';
      this.send(function (answer) {
        Notify.successfulNotification(answer.notify);
        input.closest('form').find('.error').html('');
        Main.hidePreloader(btn);
        input.val('');
      }, function (answer) {
        Main.hidePreloader(btn);
        Notify.dangerNotification(answer.notify);
        input.closest('form').find('.error').html(answer.notify);
        setTimeout(function () {
          input.closest('form').find('.error').html('');
        }, 3000);
      });
    },
    searchInvites: function searchInvites(type) {
      this.obj.method = 'searchInvites';
      this.obj.type = type;
      this.send(function (answer) {
        $('div.invite-statistics-left').html(answer.html);
      }, function (answer) {});
    },
    requestWithdrawBonus: function requestWithdrawBonus(value) {
      this.obj.method = 'requestWithdrawBonus';
      this.obj.value = value.length === 0 ? 0 : value;
      this.send(function () {
        $('div.how-much-block').hide();
        $('div.how-much-done').css('display', 'flex');
      }, function (answer) {
        $('#request-withdraw-error').show().text(answer.errorText);
        setTimeout(function () {
          $('#request-withdraw-error').hide().text('');
        }, 30000);
      });
    }
  }
};